import { render, staticRenderFns } from "./InformacionEvento.vue?vue&type=template&id=1b613d1a&scoped=true&"
import script from "./InformacionEvento.vue?vue&type=script&lang=js&"
export * from "./InformacionEvento.vue?vue&type=script&lang=js&"
import style0 from "./InformacionEvento.vue?vue&type=style&index=0&id=1b613d1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b613d1a",
  null
  
)

export default component.exports